// @ts-nocheck
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import NewFromTemplateIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import Warning from '@material-ui/icons/Warning';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import AbilityProvider from '../../permissionsUtils/AbilityProvider';
import * as CardActions from '../../redux/actions/card.actions';
import * as UtilActions from '../../redux/actions/utils.actions';
import { BLUE, CREDENTIAL_CATEGORIES, CREDENTIAL_RULE_STATUSES, PERMISSIONS, PERMISSION_ENTITIES, RESERVATION_STATUSES, RESERVATION_STATUSES_PARAMETERS, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName, isUserWithoutEmail, localizeHelpCenterLink } from '../../_config/utils';
import CredentialActionsMenu from '../Credentials/CredentialActionsMenu.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import Tag from '../Tag.jsx';
import RemoveEmailIconCustom from '../CustomIcons/RemoveEmailIconCustom.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  guestTag: {
    padding: 3,
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guestRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 40,
    height: 40,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    marginRight: 10,
    width: 'max-content',
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, companyConfigurations: state.user.companyConfigurations, cards: state.cards, themeName: state.settings.items.theme.data.themeName }))
class HyperKeysTableView extends React.Component {

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(CardActions.setOperationalMode(false));
  }

  render() {
    const {
      classes,
      cards: { hyperKeysData: { data, pagination: { number: currentPage, size, totalPages, totalElements } } },
      cards: { selectedHyperKey },
      onRefreshCards,
      onNewCard,
      onFetchKeysOnPage,
      viewLoading,
      onSelectKey,
      themeName,
      onDeleteHyperKey,
      onCredentialActionSelect,
      dispatch
    } = this.props;
    const canDeleteCard = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canCreateNewCard = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.CREATE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const headerColor = getColorFromThemeName(themeName);
    const validityDateFormat = dispatch(UtilActions.getCredentialValidityDateFormat());
    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, paddingLeft: 10, width: '87%' }}>
        <div>
          {!_.isEmpty(data) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="platformHyperKeys" /></h3>
                        <IconButton onClick={() => onRefreshCards()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="hyperKeysTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchKeysOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchKeysOnPage(page)}
                        />
                      )}
                    />
                    </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="hyperKeyNumber" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="authorizedUser" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="cardDescription" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="selectedCylinders" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="validity" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="cardStatus" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(data, (hyperKey) => {
                    const { credentialRule: credential } = hyperKey;
                    const days = credential && credential.daysOfTheWeek && _.orderBy(credential.daysOfTheWeek);
                    const daysOptions = _.map(moment.weekdays(true), weekday => ({
                      label: moment.weekdaysMin(moment().isoWeekday(weekday).isoWeekday()),
                      selected: _.indexOf(days, moment().isoWeekday(weekday).isoWeekday()) !== -1,
                    }));
                    const isSuperError = _.isEmpty(hyperKey.credentialRule.lockTags) || !hyperKey.user;
                    let statusColor = hyperKey.credentialRule.state !== CREDENTIAL_RULE_STATUSES.NOT_UPDATED ? '#43A047' : '#EF6C00';
                    statusColor = isSuperError ? 'red' : statusColor;
                
                    let syncStatusLabel = hyperKey.credentialRule.state === CREDENTIAL_RULE_STATUSES.NOT_UPDATED ? 'notUpdated' : 'updated';
                    syncStatusLabel = hyperKey.deleted ? 'cardDeleting' : syncStatusLabel;
                    syncStatusLabel = isSuperError ? 'credentialRuleInvalid' : syncStatusLabel;

                    const isInvalidNoTags = _.isEmpty(credential.lockTags) || _.isEmpty(credential.guestTags);
                    const credentialStatus = isInvalidNoTags ? RESERVATION_STATUSES.NO_TAGS : credential.status;

                    const isUserDeleted = hyperKey && hyperKey.user && hyperKey.user.email && !_.includes(hyperKey.user.email, '@');
                    
                    return (
                      <TableRow
                        key={hyperKey.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectKey(hyperKey)}
                        selected={selectedHyperKey && selectedHyperKey.id === hyperKey.id}
                      >
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <img src="/imgs/common/f9000/key_outlined.png" style={{ width: 70, marginTop: 15, marginLeft: 10 }} />
                            <h5 style={{ flex: 1, fontSize: 16, fontWeight: 'bold', color: '#3f3f3f', marginTop: 10 }}>
                              {`#${hyperKey.deviceId}`}
                            </h5>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ display: 'flex', alignItems: 'center' }}>
                            {hyperKey && hyperKey.user && (
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {!isUserDeleted ? (
                                  <div>
                                    <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{`${hyperKey.user.firstname} ${hyperKey.user.lastname}`}</h5>
                                    {isUserWithoutEmail(hyperKey.user) ?  (
                                      <div style={{ display: 'flex', marginTop: 7, marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}>
                                        <RemoveEmailIconCustom style={{ color: '#3f3f3f', width: 15, marginRight: 5 }} />
                                        <h5 style={{ color: '#3f3f3f', margin: 0 }}><Entity entity="noEmailSet" /></h5>
                                      </div>
                                    ) : (<h5 style={{ marginTop: 0 }}>{hyperKey.user.email}</h5>)}
                                  </div>
                                ) : (
                                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Warning style={{ fontSize: 15, color: 'red', marginTop: 2 }} />
                                    <h5 style={{ fontWeight: 'bold', margin: 0, marginLeft: 5, fontSize: 16, color: 'red' }}><Entity entity="userDeleted" /></h5>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.guestRowContainer}>
                            {hyperKey.notes ? <h5 style={{ fontSize: 14, fontStyle: 'italic' }}>{`${hyperKey.notes}`}</h5> : null}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tags-container">
                            {_.map(hyperKey.credentialRule.lockTags, tag =>
                              <Tag
                                key={tag.id}
                                tag={tag}
                              />)}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ paddingBottom: 6, minWidth: 280, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {credentialStatus ? (
                              <h5 style={{ fontWeight: 'bold', marginTop: 4, marginBottom: 6 }}>
                                <Entity
                                  key={`status_${credentialStatus}`}
                                  style={{ textTransform: 'uppercase', color: RESERVATION_STATUSES_PARAMETERS[credentialStatus].color }}
                                  entity={RESERVATION_STATUSES_PARAMETERS[credentialStatus].string}
                                />
                              </h5>
                            ) : null}
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                                {`${moment(credential.dateInterval.from).format(validityDateFormat)} - ${moment(credential.dateInterval.to).format(validityDateFormat)}`}
                              </h5>
                            </div>
                            <h5 style={{ color: '#3f3f3f', margin: 0, marginTop: 5 }}>{`${moment(credential.timeIntervalFrom).format('LT')} - ${moment(credential.timeIntervalTo).format('LT')}`}</h5>
                            <div style={{ marginTop: 5, display: 'flex', justifyContent: 'flex-end' }}>
                              {_.map(daysOptions, option => (
                                <h6 key={option.label} style={{ margin: 0, marginRight: 7, color: option.selected ? '#3f3f3f' : 'gray', fontWeight: option.selected ? 'bold' : 'normal' }}>
                                  {option.label.toUpperCase()}
                                </h6>
                                ))}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.guestRowContainer}>
                            <h5 style={{ fontWeight: 'bold', fontSize: 13 }}>
                              <Entity
                                key={`status_${hyperKey.credentialRule.state}`}
                                style={{ textTransform: 'uppercase', color: statusColor }}
                                entity={syncStatusLabel}
                              />
                            </h5>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            {canCreateNewCard ? (
                              <CredentialActionsMenu
                                credentialType={CREDENTIAL_CATEGORIES.F9000}
                                onActionSelect={(action) => onCredentialActionSelect(hyperKey, action)}
                                buttonStyle={{ marginRight: 10 }}
                              />
                            ) : null}
                            {canDeleteCard ? (
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onDeleteHyperKey(hyperKey);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="delete" />
                                <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            ) : null}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="hyperKeysTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchKeysOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchKeysOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <div>
                    <EmptyView
                      title="noHyperKey"
                      onNewEntity={canCreateNewCard ? () => onNewCard() : null}
                      newEntityTitle="addHyperKeys"
                      subtitle="startCreatingHyperKeys"
                      iconName="icon-simple-line-icons-credit-card"
                      onShowInfo={() => window.open(localizeHelpCenterLink('luckey-f9000-mechatronic-keys'))}
                    />
                  </div>
                ) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(HyperKeysTableView);
